import React from 'react';

import FormStepContainer from './FormStepContainer';
import ClinicBillingForm from './ClinicBillingForm';

const ClinicBillingStep = () => (
  <FormStepContainer title="Dados de Faturamento">
    <ClinicBillingForm />
  </FormStepContainer>
);

export default ClinicBillingStep;
